// betting_analysis field names differ by sport
export const CFB_LINE_KEYS = {
    home: 'home_spread',
    away: 'away_spread',
    homeOdds: 'home_spread_odds',
    awayOdds: 'away_spread_odds'
};
export const NFL_LINE_KEYS = {
    home: 'spread_home',
    away: 'spread_away',
    homeOdds: 'spread_home_odds',
    awayOdds: 'spread_away_odds'
};
// A move this big means the stored odds were priced for a different number.
// Smaller gaps are mostly the edge data's cross-book average (quarter points).
const STALE_ODDS_MOVE = 0.5;
// The pipeline's edge jobs (Sharpshot/_ML_microservice/market_lines.py) now refresh
// betting_analysis with the same bettable line as edge_context.line_movement.current_spread,
// so this is normally a no-op. It's the fallback for when they disagree (e.g. the odds pull
// was blocked or a prediction run rewrote the file after the edge job): use the newer line
// everywhere, and drop the stored odds only when the line has really moved.
export const syncCurrentLine = (prediction, keys) => {
    const current = prediction.edge_context?.line_movement?.current_spread;
    const analysis = prediction.betting_analysis;
    if (!analysis || current === null || current === undefined || analysis[keys.home] === current) {
        return prediction;
    }
    const stored = typeof analysis[keys.home] === 'number' ? analysis[keys.home] : null;
    const oddsStale = stored === null || Math.abs(stored - current) >= STALE_ODDS_MOVE;
    return {
        ...prediction,
        betting_analysis: {
            ...analysis,
            [keys.home]: current,
            [keys.away]: current === 0 ? 0 : -current,
            ...(oddsStale ? { [keys.homeOdds]: undefined, [keys.awayOdds]: undefined } : {})
        }
    };
};
